import { Injectable, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { GasMenu } from './gas-menu.namespace';

/**
 * @description Сервис для управления меню
 * @description В appComponent необходимо прописать ваши роуты
 */
@Injectable({
  providedIn: 'root',
})
export class GasMenuService {
  public metaSubject$ = new BehaviorSubject<GasMenu.Meta>(undefined);
  public bottomButtonsSubject$ = new BehaviorSubject<GasMenu.Bottom[]>(undefined);
  public userDataSubject$ = new BehaviorSubject<GasMenu.User>(undefined);
  public activeRouteSubject$ = new BehaviorSubject<string>('/');

  public meta$: Observable<GasMenu.Meta> = this.metaSubject$.asObservable().pipe(shareReplay(1));
  public bottomButtons$: Observable<GasMenu.Bottom[]> = this.bottomButtonsSubject$.asObservable().pipe(shareReplay(1));
  public userData$: Observable<GasMenu.User> = this.userDataSubject$.asObservable().pipe(shareReplay(1));
  public activeRoute$: Observable<string> = this.activeRouteSubject$.asObservable().pipe(shareReplay(1));

  public set meta(data: GasMenu.Meta) {
    this.metaSubject$.next(data);
  }

  public get meta(): GasMenu.Meta {
    return this.metaSubject$.getValue();
  }

  public set bottomButtons(buttons: GasMenu.Bottom[]) {
    this.bottomButtonsSubject$.next(buttons);
  }

  public get bottomButtons(): GasMenu.Bottom[] {
    return this.bottomButtonsSubject$.getValue();
  }

  public set userData(data: GasMenu.User) {
    this.userDataSubject$.next(data);
  }

  public get userData(): GasMenu.User {
    return this.userDataSubject$.getValue();
  }

  public set userLoading(isLoading: boolean) {
    this.userDataSubject$.next({ ...this.userDataSubject$.value, isLoading });
  }

  public get userLoading(): boolean {
    return this.userDataSubject$.getValue().isLoading;
  }

  public set activeRoute(route: string) {
    this.activeRouteSubject$.next(route);
  }

  public get activeRoute(): string {
    return this.activeRouteSubject$.getValue();
  }

  public constructor(
    @Optional() private router: Router,
  ) {}

  public isActiveRoute(link: string): boolean {
    return this.router?.isActive(link || '', false) || false;
  }

  /**
   * Обновляем часть данных, например количество уведомлений
   * Для этого передаем роут и часть данных(или все) из GasMenu.Route
   */
  public updateRoute(route: string, routeData: Partial<GasMenu.Route>): void {
    this.meta.routes
      .forEach((innerRouteData: GasMenu.Route) => {
        if (innerRouteData.route === route) {
          innerRouteData = { ...innerRouteData, ...routeData };
        }
      });
  }
}
